import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=04e7f0ab&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=04e7f0ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7f0ab",
  null
  
)

export default component.exports